import React from 'react';
import SimpleInOutBoardDrawer from './SimpleInOutBoardDrawer';
import SimpleInOutStatusModal from './SimpleInOutStatusModal';
import { SIMPLE_INOUT_OPEN_DOTBOARD_EVENT, SIMPLE_INOUT_OPEN_STATUS_EVENT } from './simpleInOutEvents';

/** One dotboard drawer and one My status modal for the whole app (mounted in AppShell). */
export default function SimpleInOutOverlays() {
  const [boardOpen, setBoardOpen] = React.useState(false);
  const [statusOpen, setStatusOpen] = React.useState(false);

  React.useEffect(function listenForSimpleInOutOpeners() {
    function openBoard() {
      setStatusOpen(false);
      setBoardOpen(true);
    }
    function openStatus() {
      setBoardOpen(false);
      setStatusOpen(true);
    }
    window.addEventListener(SIMPLE_INOUT_OPEN_DOTBOARD_EVENT, openBoard);
    window.addEventListener(SIMPLE_INOUT_OPEN_STATUS_EVENT, openStatus);
    return function stopListeningForSimpleInOutOpeners() {
      window.removeEventListener(SIMPLE_INOUT_OPEN_DOTBOARD_EVENT, openBoard);
      window.removeEventListener(SIMPLE_INOUT_OPEN_STATUS_EVENT, openStatus);
    };
  }, []);

  const closeBoard = React.useCallback(function closeSimpleInOutBoard() {
    setBoardOpen(false);
  }, []);
  const closeStatus = React.useCallback(function closeSimpleInOutStatus() {
    setStatusOpen(false);
  }, []);

  // Mounted only while open, so pages that never open them pay for no queries.
  return (
    <>
      {boardOpen ? <SimpleInOutBoardDrawer open onClose={closeBoard} /> : null}
      {statusOpen ? <SimpleInOutStatusModal open onClose={closeStatus} /> : null}
    </>
  );
}
